import { inject, Injectable, Injector, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, type RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { buildAppDocumentTitle } from './app-document-title.util';
import { APP_ENV } from './tokens/app-environment.token';

/** Coordinates route titles, optional entity segments, and the environment label prefix. */
@Injectable({ providedIn: 'root' })
export class DocumentTitleService {
  private readonly title = inject(Title);
  private readonly appEnv = inject(APP_ENV);
  private readonly injector = inject(Injector);

  readonly entityTitle = signal<string | null>(null);

  apply(routerState: RouterStateSnapshot, strategy: TitleStrategy): void {
    const routeTitle = strategy.buildTitle(routerState);
    this.title.setTitle(
      buildAppDocumentTitle(routeTitle, {
        entityTitle: this.entityTitle(),
        environmentLabel: this.appEnv.documentTitleEnvironmentLabel,
      }),
    );
  }

  setEntityTitle(value: string | null): void {
    this.entityTitle.set(value?.trim() || null);
    const router = this.injector.get(Router);
    const strategy = this.injector.get(TitleStrategy);
    this.apply(router.routerState.snapshot, strategy);
  }

  clearEntityTitle(): void {
    this.setEntityTitle(null);
  }
}
